export default "__VITE_ASSET__rHHWo2wm__"